<template>
  <div class="mymapM">
    <!--  加载等待  -->
    <div v-if="loading && !readMapFlag" class="loading">
      <van-loading type="spinner" />
    </div>
    <div v-if="false" class="loading" @click="handleToPosition">
      <button>定位</button>
    </div>
    <!-- 搜索框 -->
<!--    <div class="search-box" v-if="$route.params.localName !== 'addcheck'">-->
    <div class="search-box" v-if="false">
      <div class="search-postion">
<!--        <span class="buts buts_back"></span>-->
        <span class="buts buts_back" @click="$router.push($route.params.localName)" v-if="readMapFlag">返回</span>
        <input type="text" placeholder="输入关键字搜索" :disabled="loading" v-model="search_key" />
        <span class="clear" v-if="search_key" @click="search_key ='' ">
          <van-icon color="#8f8f8f" name="clear" />
        </span>
        <span class="buts border_but" @click="keySearch">捜索</span>
      </div>
    </div>
    <!-- 高德地图 -->
    <div class="con-map"  :class="{active:$route.params.localName === 'addfollowup'}"  v-if="!search_key">
      <!--地图-->
      <div class="mapbox">
        <div class="map" id="container"></div>
        <div class="sign"></div>
      </div>
    </div>
    <!-- 高德地图当前位置地址列表 -->
    <div class="con-box" :class="{active:$route.params.localName === 'addfollowup'}" v-if="!search_key && !readMapFlag">
      <!--地址列表-->
      <div class="Hlist-box">
        <ul>
          <li v-for="item in lists" :key="item.id" @click="onAddressLi(item)">
            <b>
              <van-icon color="#a6a6a6" name="location-o" />
            </b>
            <div>
              <span>{{item.name}}</span>
              <p>{{item.address?item.address:'暂无数据'}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 高德地图搜索地址列表 -->
    <div class="search-list" v-if="search_key">
      <ul>
        <li v-for="item in search_list" :key="item.id" @click="onSearchLi(item.location)">
          <!--      <li>-->
          <span>{{item.name}}</span>
          <p>{{item.address?item.address:'暂无数据'}}</p>
        </li>
        <li v-if="noSearchShow">
          <p>暂无搜索结果</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import AMap from 'AMap'
// import { post } from '../api/api'
import recordPageTime from '../mixin/minin'
export default {
  data () {
    return {
      center: [], // 经度+纬度
      search_key: '', // 搜索值
      lists: [], // 地点列表
      search_list: [], // 搜索结果列表
      marker: '',
      loading: false,
      noSearchShow: false, // 无搜索结果提示，无搜索结果时会显示暂无搜索结果
      readMapFlag: false
    }
  },
  beforeMount () {
    if (this.$route.params.localName === 'verifydetail') {
      this.readMapFlag = true
    }
  },
  mounted () {
    if (this.$route.params.lng && this.$route.params.lat) {
      this.center.push(this.$route.params.lng)
      this.center.push(this.$route.params.lat)
    }
    this.adMap()
  },
  methods: {
    handleToPosition () {
      this.center = []
      this.adMap()
    },
    adMap () {
      this.loading = true
      const _this = this
      // 初始化地图
      const map = new AMap.Map('container', {
        zoom: 14, // 缩放级别
        // center: this.center // 设置地图中心点
        resizeEnable: true // 地图初始化加载定位到当前城市
      })
      if (this.center.length === 0) {
        if (this.$store.state.mapFlag) {
          map.plugin(['AMap.Geolocation'])
          this.$store.commit('setMapFlag', false)
        }
        setTimeout(() => {
          const geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,
            timeout: 5000,
            zoomToAccuracy: true,
            buttonPosition: 'RB'
          })
          geolocation.getCurrentPosition((status, result) => {
            if (status === 'complete') {
              _this.center = [result.position.lng, result.position.lat]
              map.setCenter(_this.center)
              this.marker = new AMap.Marker({
                position: new AMap.LngLat(_this.center[0], _this.center[1]) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              })
              map.add(_this.marker)

              // 根据地图中心点查附近地点，此方法在下方
              _this.centerSearch()

              const moveendFun = e => {
                if (this.$route.params.localName === 'addfollowup' || this.$route.params.localName === 'addcheck' || this.$route.params.localName === 'verifydetail') {
                  return false
                }
                // 获取地图中心点
                const currentCenter = map.getCenter()
                _this.center = [currentCenter.lng, currentCenter.lat]
                _this.marker.setPosition([currentCenter.lng, currentCenter.lat]) // 更新标记的位置
                // 根据地图中心点查附近地点
              }

              // 更新数据
              const centerSearch = () => {
                _this.loading = true
                _this.centerSearch()
              }
              // 绑定事件移动地图事件
              map.on('mapmove', moveendFun) // 更新标记
              map.on('moveend', centerSearch) // 更新数据
            } else {
              console.log(result)
              console.log(status)
              console.log('定位失败')
            }
          })
        }, 300)
      } else {
        map.setCenter(this.center)
        // 获取初始中心点并赋值
        let currentCenter = map.getCenter() // 此方法是获取当前地图的中心点
        this.center = [currentCenter.lng, currentCenter.lat] // 将获取到的中心点的纬度经度赋值给data的center

        // 创建标记
        this.marker = new AMap.Marker({
          position: new AMap.LngLat(currentCenter.lng, currentCenter.lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        // 将创建的点标记添加到已有的地图实例：
        map.add(this.marker)

        // 根据地图中心点查附近地点，此方法在下方
        this.centerSearch()
        // 监听地图移动事件，并在移动结束后获取地图中心点并更新地点列表
        const moveendFun = e => {
          if (this.$route.params.localName === 'addfollowup' || this.$route.params.localName === 'addcheck' || this.$route.params.localName === 'verifydetail') {
            return false
          }
          // 获取地图中心点
          currentCenter = map.getCenter()
          this.center = [currentCenter.lng, currentCenter.lat]
          this.marker.setPosition([currentCenter.lng, currentCenter.lat]) // 更新标记的位置
          // 根据地图中心点查附近地点
        }
        // 更新数据
        const centerSearch = () => {
          this.loading = true
          this.centerSearch()
        }

        // 绑定事件移动地图事件
        map.on('mapmove', moveendFun) // 更新标记
        map.on('moveend', centerSearch) // 更新数据
      }
    },
    centerSearch () {
      AMap.service(['AMap.PlaceSearch'], () => {
        // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          type:
            '汽车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|地名地址信息', // 兴趣点类别
          pageSize: 20, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: '全国', // 兴趣点城市
          autoFitView: false // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 根据地图中心点查附近地点
        placeSearch.searchNearBy(
          '',
          [this.center[0], this.center[1]],
          200,
          (status, result) => {
            if (status === 'complete') {
              this.lists = result.poiList.pois // 将查询到的地点赋值
              this.loading = false
            }
          }
        )
      })
    },
    keySearch () {
      this.loading = true
      AMap.service(['AMap.PlaceSearch'], () => {
        // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          type:
            '汽车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|地名地址信息', // 兴趣点类别
          pageSize: 20, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: '全国', // 兴趣点城市
          citylimit: false, // 是否强制限制在设置的城市内搜索
          autoFitView: false // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(this.search_key, (status, result) => {
          if (status === 'complete') {
            if (result.poiList.count === 0) {
              this.noSearchShow = true
            } else {
              this.search_list = result.poiList.pois // 将查询到的地点赋值
              this.noSearchShow = false
              this.loading = false
            }
          } else {
            this.search_list = []
            this.noSearchShow = true
          }
        })
      })
    },
    onAddressLi (e) {
      const newTime = new Date()
      const MonthDate = (newTime.getMonth() + 1).toString().length === 1 ? 0 + (newTime.getMonth() + 1).toString() : (newTime.getMonth() + 1).toString()
      const DayDate = newTime.getDate().toString().length === 1 ? 0 + newTime.getDate().toString() : newTime.getDate().toString()
      const HourDate = newTime.getHours().toString().length === 1 ? 0 + newTime.getHours().toString() : newTime.getHours().toString()
      const MMDate = newTime.getMinutes().toString().length === 1 ? 0 + newTime.getMinutes().toString() : newTime.getMinutes().toString()
      const SSDate = newTime.getSeconds().toString().length === 1 ? 0 + newTime.getSeconds().toString() : newTime.getSeconds().toString()
      const locationDate = `${newTime.getFullYear()}-${MonthDate}-${DayDate} ${HourDate}:${MMDate}:${SSDate}`
      const geocoder = new AMap.Geocoder({ radius: 1000 })
      geocoder.getAddress([e.location.lng, e.location.lat], (status, result) => {
        const province = result.regeocode.addressComponent.province
        const city = result.regeocode.addressComponent.city
        const district = result.regeocode.addressComponent.district
        const address = (province + city + district) ? province + city + district + e.address : e.address
        const positionData = { address, lng: e.location.lng, lat: e.location.lat, locationDate }
        this.$store.commit('setLocationFunc', positionData)
      })
      this.marker.setPosition([e.location.lng, e.location.lat]) // 更新标记的位置
      const modifyTag = this.$route.params.modifyTag
      const routerName = this.$route.params.routerName
      const id = this.$route.params.id
      this.$router.push({
        name: this.$route.params.localName,
        params: {
          modifyTag,
          routerName,
          id
        }
      })
    },
    onSearchLi (e) {
      this.center = [e.lng, e.lat]
      this.search_key = ''
      setTimeout(() => {
        this.adMap()
      }, 5)
    }
  },
  watch: {
    search_key (newv, oldv) {
      if (newv === '') {
        this.search_list = []
        this.noSearchShow = false
        setTimeout(() => {
          this.adMap()
        }, 5)
      }
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.mymapM
  position : relative
  height: 100vh
  width : 100vw
  background-color : #eceeee
  padding-bottom : 64px
  overflow-x : hidden
  overflow-y : scroll
  .loading
    position : absolute
    top: 50%
    left : 50%
    transform translate(-50%,-50%)
    z-index : 1000
  .search-box
    position : fixed
    top:0
    left :0
    width : 100vw
    z-index : 990
    .search-postion
      display : flex
      align-items : center
      background-color : #ffffff
      border-bottom : 1px solid #bfbec4
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .buts
        width : 80px
        padding: 16px
        text-align : center
      .buts_back
        background-color : none
      .clear
        width : 40px
        padding: 16px
      input
        height : 16px
        padding : 16px 0
        text-indent : 16px
        border : none
        flex : 1
  .con-map
    position : fixed
    top: 0
    left : 0
    height : 600px
    width : 100vw
    z-index : 990
    &.active
      top:0
    .mapbox
      height : 600px
      background-color : #ffffff
      .map
        width : 100%
        height : 100%
  .con-box
    margin-top : 680px
    &.active
      margin-top : 630px
    .Hlist-box
      width : 96%
      margin : 0 auto 0
      background-color : #ffffff
      border-radius : 5px
      li
        display : flex
        align-items : center
        padding : 16px
        border-bottom : 1px solid #bfbec4
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        b
          width : 40px
        div
          flex : 1
          margin-left : 16px
          p
            margin : 16px 0 0 0
            color: #bfbec4
  .search-list
    width : 96%
    margin : 84px auto 0
    border-radius : 5px
    background-color : #ffffff
    li
      box-sizing : border-box
      padding : 16px
      border-bottom: 1px solid #d9d9d9
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      color: #333333
      p
        margin : 16px 0 0 0
        color: #bfbec4
</style>
